import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-profile-photo-dialog',
    templateUrl: './profile-photo-dialog.component.html',
    styleUrls: ['./profile-photo-dialog.component.scss'],
    standalone: false
})
export class ProfilePhotoDialogComponent {
  previewUrl: string | ArrayBuffer | null = null;
  selectedFile: File | null = null;

  constructor(
    public dialogRef: MatDialogRef<ProfilePhotoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { currentPhoto: string }
  ) {
    this.previewUrl = data.currentPhoto;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.selectedFile = input.files[0];
      const reader = new FileReader();
      reader.onload = e => this.previewUrl = reader.result;
      reader.readAsDataURL(this.selectedFile);
    }
  }

  onSave(): void {
    if (this.selectedFile) {
      // El componente se abre con MatDialog; el padre recibe el archivo por
      // afterClosed(), no por un @Output (que en un dialogo no puede enlazarse).
      this.dialogRef.close(this.selectedFile);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
